import {SERVER_API_PLATFORMJK} from '../../../constans/index';
import {RSAA} from 'redux-api-middleware';
import {GET_ENDPOINT_FUNBOT} from "../../../types/index";
import queryString from 'query-string';
import headers from "../../../utils/headers";

const get_endpoint_action = (limit = 100, page = 1) => ({

    [RSAA]: {
        endpoint: () => {
            let parsed = {
                'limit': limit,
                'page': page,
            }
            let query_param = queryString.stringify(parsed);
            return `${SERVER_API_PLATFORMJK}/api/endpoints?${query_param}`
        },
        method: 'GET',
        headers: (headers()),
        types: [
            'REQUEST_ENDPOINT_FUNBOT',
            {
                type: GET_ENDPOINT_FUNBOT,
                payload:async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        })
                        return {
                            "code": 0,
                            "type": "getEndPoints",
                            "data": data
                        }
                    }

                }
            },
            'FAILURE_ENDPOINT_FUNBOT'
        ]
    }

})

export {get_endpoint_action}